import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18 8V6c0-2.2-1.8-4-4-4h-3C8.8 2 7 3.8 7 6v2c-.811 0-1.507.485-1.82 1.18-.09.199-.142.416-.162.643l2.498 2.498c.651.651.651 1.708 0 2.359l-2.498 2.498c.018.202.058.396.132.576C5.448 18.484 6.163 19 7 19h11c1.105 0 2-.895 2-2v-7c0-1.105-.895-2-2-2zM8 6c0-1.654 1.346-3 3-3h3c1.654 0 3 1.346 3 3v2H8V6zm7 8h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z',
    'M6.354 13.146l-3-3A.498.498 0 0 0 3 10c-.109 0-.214.043-.305.114-.016.012-.035.018-.049.033a.5003.5003 0 0 0 0 .707L4.792 13H.499c-.276 0-.5.224-.5.5s.224.5.5.5h4.293l-2.146 2.146a.5003.5003 0 0 0 0 .707c.014.014.033.02.049.033.09.071.196.114.305.114.128 0 .256-.049.354-.146l3-3a.5003.5003 0 0 0 0-.707z',
  ],
  height: 20,
  width: 20,
});
